import React from "react";
import {
  Printer,
  RotateCcw,
  FileDown,
  Link2,
  ExternalLink,
} from "lucide-react";
import { fullAppUrl } from "../lib/share";

export const Header = ({
  unit,
  setUnit,
  onPrint,
  onReset,
  onExportPDF,
  onShare,
  embed,
}) => {
  return (
    <header
      data-testid="app-header"
      className={`z-40 border-b border-white/10 bg-[#0a0b0e]/85 backdrop-blur no-print ${
        embed ? "" : "sticky top-0"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-3 flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-3">
          <img
            src={`${process.env.PUBLIC_URL || ""}/kraken-logo.png`}
            alt="Kraken PP"
            className="h-10 sm:h-12 w-auto shrink-0 object-contain drop-shadow-[0_0_18px_rgba(205,56,61,0.35)]"
            data-testid="kraken-logo"
          />
          <div className="leading-tight border-l border-white/10 pl-3 hidden sm:block">
            <div className="eyebrow text-[10px]">
              Calculateur de charge
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-3">
          <div
            data-testid="unit-toggle-lbs-kg"
            className="flex items-center rounded-sm border border-white/10 overflow-hidden text-xs font-mono"
          >
            <button
              data-testid="unit-lbs"
              onClick={() => setUnit("lbs")}
              className={`px-3 py-1.5 uppercase tracking-widest transition ${
                unit === "lbs"
                  ? "bg-[#cd383d] text-white"
                  : "text-slate-400 hover:text-white"
              }`}
            >
              lbs
            </button>
            <button
              data-testid="unit-kg"
              onClick={() => setUnit("kg")}
              className={`px-3 py-1.5 uppercase tracking-widest transition ${
                unit === "kg"
                  ? "bg-[#cd383d] text-white"
                  : "text-slate-400 hover:text-white"
              }`}
            >
              kg
            </button>
          </div>

          <button
            data-testid="button-export-pdf"
            onClick={onExportPDF}
            className="btn-red px-3 py-1.5 text-xs rounded-sm flex items-center gap-2"
          >
            <FileDown size={14} />
            <span className="hidden sm:inline">Fiche PDF</span>
          </button>

          <button
            data-testid="button-share-link"
            onClick={onShare}
            className="btn-ghost px-3 py-1.5 text-xs rounded-sm flex items-center gap-2"
          >
            <Link2 size={14} />
            <span className="hidden sm:inline">Partager</span>
          </button>

          <button
            data-testid="button-print-sheet"
            onClick={onPrint}
            className="btn-ghost px-3 py-1.5 text-xs rounded-sm flex items-center gap-2"
          >
            <Printer size={14} />
            <span className="hidden sm:inline">Imprimer</span>
          </button>

          {embed && (
            <a
              href={fullAppUrl()}
              target="_blank"
              rel="noreferrer"
              data-testid="embed-open-full-app"
              className="btn-ghost px-3 py-1.5 text-xs rounded-sm flex items-center gap-2"
            >
              <ExternalLink size={14} />
              <span className="hidden sm:inline">Ouvrir l'app</span>
            </a>
          )}

          <button
            data-testid="button-reset-data"
            onClick={onReset}
            className="btn-ghost px-3 py-1.5 text-xs rounded-sm flex items-center gap-2"
          >
            <RotateCcw size={14} />
            <span className="hidden sm:inline">Réinitialiser</span>
          </button>
        </div>
      </div>
    </header>
  );
};
